module.exports = __webpack_public_path__ + "static/media/photo35.d32c70c6.jpg";